app.service("OptionTermService", ['$rootScope', function ($rootScope) {

    const siteHelper = $rootScope.site_helper;

    const modelConstructor = $rootScope.model_constructor;

    const ModelChoice = modelConstructor.ModelChoice;

    this.option_ids = [
        'edge_option',
        'clicbox_colour',
        'handle_colour',
        'hinge_colour',
        'hinge_option',
        'drawer_colour',
        'hettich_colour',
        'selected_door_option',
        'handle_style',
        'handle_shape_inset',
        'handle_position',
        'handle_position_inset',
        'handle_position_segreto',
        'handle_position_integra',
        'handle_position_knebworth',
        'midrail',
        'frame_type',
        'glazing',
        'overhang',
        'internal',
        'internal_left',
        'internal_right',
        'wingline_internal_left',
        'wingline_internal_right',
        'drip_tray',
        'door_size',
        'door_sloping_angle',
        'door_sloping_spacing',
        'panel_profiled_edge',
        'panel_angle',
        'panel_radius',
        'panel_corner_position',
        'panel_side_angle',
        'panel_corner_radius',
        'panel_corner_profile'
    ];

    const OptionTermModel = modelConstructor.extend(modelConstructor.BasicModel, {
        name: null,
        id: "option_term",
        allow_single_choice_route: true,
        option_id: null,
        default_choice_id: null,
        required: false,
        always_visible: false,
        narratives: null,
        sort_index: 0,

        is_server_option_term: false,
        is_complex_option_term: false,
        prevent_deselect: false,
        server_option_term: null,
        complex_option_term_choices: {},
        parent_complex_option_term_model: null,

        isChoiceDisabled: function (choiceID, product) {
            if (this.root.is_complex_option_term) {
                const complexChoice = this.root.complexOptionTermChoice(choiceID, product, !this.root.getParentComplexOptionTermChoiceID(product));
                if (!complexChoice || complexChoice.disabled) {
                    return true;
                }
            }
            const choice = this.root.choices[choiceID];
            return choice && choice.disabled;
        },

        isChoiceHidden: function (choiceID, product) {
            if (this.root.is_complex_option_term) {
                const complexChoice = this.root.complexOptionTermChoice(choiceID, product, !this.root.getParentComplexOptionTermChoiceID(product));
                if (!complexChoice || !!complexChoice.hidden) {
                    return true;
                }
            }
            const choice = this.root.choices[choiceID];
            return !choice || !!choice.hidden;
        },

        getParentComplexOptionTermChoiceID: function (product) {
            if (this.root.parent_complex_option_term_model) {
                const parentComplexChoice = this.root.parent_complex_option_term_model.currentComplexOptionTermChoice(product);
                if (parentComplexChoice) {
                    return parentComplexChoice.id;
                }
            }

            return 0
        },

        complexOptionTermChoice: function (optionTermID, product, allowDefaultParent) {
            const complexChoices = this.root.complex_option_term_choices[optionTermID];
            let parentID = this.root.getParentComplexOptionTermChoiceID(product);
            if (complexChoices) {
                if (allowDefaultParent && !complexChoices[parentID]) {
                    for (let complexID in complexChoices) {
                        parentID = complexID;
                        break;
                    }
                }
                return complexChoices[parentID] ? complexChoices[parentID] : null;
            }
            return null;
        },

        currentComplexOptionTermChoice: function (product) {
            const optionTermID = product.option_term_ids[this.root.option_id];
            const complexChoice = optionTermID ? this.root.complexOptionTermChoice(optionTermID, product) : null;
            return complexChoice ? complexChoice : null;
        },

        applyInitState: function (product) {
            const model = this.root;

            let parentComplexOptionTermModel = null;
            if (model.is_complex_option_term) {
                const optionProductModel = product.getOptionProductModel();
                for (let i = 0; i < optionProductModel.term_model_list.length; i++) {
                    const checkOptionTermModel = optionProductModel.term_model_list[i];
                    if (checkOptionTermModel === model) {
                        break;
                    }
                    if (checkOptionTermModel.is_complex_option_term) {
                        parentComplexOptionTermModel = checkOptionTermModel;
                    }
                }

            }
            model.parent_complex_option_term_model = parentComplexOptionTermModel;
            model.was_hidden = !model.hidden;
            handleVisibilityChange(model, product);

            model.input_sections = {};
            model.input_name = 'option_' + model.option_id;
            if (model.input_section_list) {
                for (let i = 0; i < model.input_section_list.length; i++) {
                    const inputSection = model.input_section_list[i];
                    if (!inputSection.id) {
                        inputSection.id = "inputSection_" + i;
                    }

                    inputSection.value = null;
                    inputSection.input_name = 'option_' + model.option_id + '_section_' + inputSection.id;

                    model.input_sections[inputSection.id] = inputSection;
                    inputSection.input_list = inputSection.input_list ? inputSection.input_list : [];
                    inputSection.inputs = {};
                    for (let j = 0; j < inputSection.input_list.length; j++) {
                        const input = inputSection.input_list[j];
                        input.input_name = 'option_' + model.option_id + '_section_' + inputSection.id + '_input_' + input.id;
                    }
                }
            } else {
                model.input_section_list = [];
            }
            model.applyResetState(product);
        },

        applyResetState: function (product) {
            const model = this.root;
            if (model.input_section_list) {
                product.option_term_values[model.option_id] = {};
                for (let i = 0; i < model.input_section_list.length; i++) {
                    const inputSection = model.input_section_list[i];
                    if (inputSection && inputSection.input_list) {
                        for (let j = 0; j < inputSection.input_list.length; j++) {
                            const input = inputSection.input_list[j];
                            if (input.default_value && !inputSection.hidden && !input.hidden) {
                                product.option_term_values[model.option_id][input.id] = input.default_value;
                            }
                        }
                    }
                }
            }
        },

        applyCurrentState: function (product) {
            return false;
        }
    });

    this.factory = new modelConstructor.ModelFactory({
        birth: function (values) {
            return new OptionTermModel(values);
        },

        validVariationPointers: function (variationIDs) {
            return ['option_id', 'browse_id', 'solution_id', 'door_type_id', 'site_range_id', 'style_id', 'colour_id', 'assembly_id', 'base_component_id', 'parent_category_id', 'source_id'];
        },

        applyModelVariation: applyModelVariation
    });


    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const optionID = variationIDs.option_id;

        let variationValues = null;
        let disabled = false;

        switch (optionID) {
            case "clicbox_colour":
                variationValues = getClicboxColourValues(model, variationIDs);
                break;
            case "hinge_colour":
                variationValues = getHingeColourValues(model, variationIDs);
                break;
            case "hinge_option":
                variationValues = getHingeOptionValues(model, variationIDs);
                break;
            case "drawer_colour":
                variationValues = getDrawerColourValues(model, variationIDs);
                break;
            case "hettich_colour":
                variationValues = getHettichColourValues(model, variationIDs);
                break;
            case "selected_door_option":
                variationValues = getSelectedDoorOptionValues(model, variationIDs);
                break;
            case "handle_style":
                variationValues = getHandleStyleValues(model, variationIDs);
                break;
            case "edge_option":
                variationValues = getEdgeOptionValues(model, variationIDs);
                break;
            case "handle_shape_inset":
                variationValues = getHandleShapeInsetValues(model, variationIDs);
                break;
            case "handle_position":
                variationValues = getHandlePositionValues(model, variationIDs);
                break;
            case "handle_position_inset":
                variationValues = getHandlePositionInsetValues(model, variationIDs);
                break;
            case "handle_position_segreto":
                variationValues = getHandlePositionSegretoValues(model, variationIDs);
                break;
            case "handle_position_integra":
                variationValues = getHandlePositionIntegraValues(model, variationIDs);
                break;
            case "handle_position_knebworth":
                variationValues = getHandlePositionKnebworthValues(model, variationIDs);
                break;
            case "handle_colour":
                variationValues = getHandleColourValues(model, variationIDs);
                break;
            case "midrail":
                variationValues = getMidrailValues(model, variationIDs);
                break;
            case "frame_type":
                variationValues = getFrameTypeValues(model, variationIDs);
                break;
            case "glazing":
                variationValues = getGlazingValues(model, variationIDs);
                break;
            case "overhang":
                variationValues = getOverhangValues(model, variationIDs);
                break;
            case "internal":
                variationValues = getInternalValues(model, variationIDs);
                break;
            case "internal_left":
                variationValues = getInternalLeftValues(model, variationIDs);
                break;
            case "internal_right":
                variationValues = getInternalRightValues(model, variationIDs);
                break;
            case "wingline_internal_left":
                variationValues = getWinglineInternalLeftValues(model, variationIDs);
                break;
            case "wingline_internal_right":
                variationValues = getWinglineInternalRightValues(model, variationIDs);
                break;
            case "drip_tray":
                variationValues = getDripTrayValues(model, variationIDs);
                break;
            case "door_size":
                variationValues = getDoorSizeValues(model, variationIDs);
                break;
            case "door_sloping_angle":
                variationValues = getDoorSlopingAngleValues(model, variationIDs);
                break;
            case "door_sloping_spacing":
                variationValues = getDoorSlopingSpacingValues(model, variationIDs);
                break;
            case "panel_profiled_edge":
                variationValues = getPanelProfiledEdgeValues(model, variationIDs);
                break;
            case "panel_angle":
                variationValues = getPanelAngleValues(model, variationIDs);
                break;
            case "panel_radius":
                variationValues = getPanelRadiusValues(model, variationIDs);
                break;
            case "panel_corner_position":
                variationValues = getPanelCornerPositionValues(model, variationIDs);
                break;
            case "panel_side_angle":
                variationValues = getPanelSideAngleValues(model, variationIDs);
                break;
            case "panel_corner_radius":
                variationValues = getPanelCornerRadiusValues(model, variationIDs);
                break;
            case "panel_corner_profile":
                variationValues = getPanelCornerProfileValues(model, variationIDs);
                break;
            default:
                disabled = true;
                break;
        }


        const narratives = {};
        let unavailable = false;

        let choice, choiceID;

        if (variationValues) {
            const isProduct = variationIDs.source_id === "product";
            if (variationValues.choices) {
                for (choiceID in variationValues.choices) {
                    choice = variationValues.choices[choiceID];
                    if (isProduct && choice.remote_id) {
                        const orderIndex = variationValues.choice_order ? variationValues.choice_order.indexOf(choiceID) : -1;
                        if (orderIndex >= 0) {
                            variationValues.choice_order[orderIndex] = choice.remote_id;
                        }
                        choice.id = choice.remote_id;
                        delete variationValues.choices[choiceID];
                        variationValues.choices[choice.remote_id] = choice;
                        choiceID = choice.remote_id;
                    }
                    choice.option_id = optionID;
                    if (choice.narratives) {
                        for (let i = 0; i < choice.narratives.length; i++) {
                            narratives[choice.narratives[i]] = true;
                        }
                    }
                }
            }
            if (variationValues.choice_order) {
                for (let i = 0; i < variationValues.choice_order.length; i++) {
                    choice = variationValues.choices[variationValues.choice_order[i]];
                    if (choice) {
                        choice.sort_index = i;
                    }
                }
            }
        } else {
            unavailable = true;
            variationValues = {};
        }

        variationValues.option_id = optionID;
        variationValues.narratives = narratives;
        variationValues.unavailable = unavailable;
        variationValues.disabled = disabled;

        siteHelper.applyValues(model, variationValues);
    }

    function initSimpleServerOption(optionID, product) {
        const optionTermModel = product.getOptionProductModel().term_models[optionID];
        if (!optionTermModel || optionTermModel.is_complex_option_term) {
            return;
        }

        const serverOptionTerm = optionTermModel.server_option_term;

        if (!serverOptionTerm) {
            return;
        }
        if (serverOptionTerm.name) {
            optionTermModel.name = serverOptionTerm.name
        }
        if (serverOptionTerm.items) {

            const choiceOrder = [];
            for (let i = 0; i < optionTermModel.choice_order.length; i++) {
                const choiceID = optionTermModel.choice_order[i];
                if (serverOptionTerm.items[choiceID] && optionTermModel.choices[choiceID]) {
                    const choice = optionTermModel.choices[choiceID];
                    const item = serverOptionTerm.items[choiceID];
                    choiceOrder.push(choiceID);
                    if (item.name) {
                        choice.name = item.name
                    }
                }
            }
            optionTermModel.choice_order = choiceOrder;
        }
    }

    function handleVisibilityChange(model, product) {
        const modelHiddenChange = !!model.hidden !== !!model.was_hidden;
        model.was_hidden = false;
        if (model.input_section_list) {
            for (let i = 0; i < model.input_section_list.length; i++) {
                const inputSection = model.input_section_list[i];
                const sectionHiddenChange = !!inputSection.hidden !== !!inputSection.was_hidden;
                inputSection.was_hidden = false;
                if (modelHiddenChange || sectionHiddenChange) {
                    for (let j = 0; j < inputSection.input_list.length; j++) {
                        const input = inputSection.input_list[j];
                        if (!product.option_term_values[model.option_id]) {
                            product.option_term_values[model.option_id] = {};
                        }
                        product.option_term_values[model.option_id][input.id] = !model.hidden && !inputSection.hidden ? input.default_value : null;
                    }
                }
            }
        }
    }

    function getClicboxColourValues(model, variationIDs) {

        const choices = {
            white: new ModelChoice({
                name: "White",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-white.jpeg",
                img_class: "with-grey-border"
            }),
            urban_oak: new ModelChoice({
                name: "Urban Oak",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-urban-oak.jpg?v=2"
            }),
            grey: new ModelChoice({
                name: "Grey",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-grey.png"
            }),
            anthracite: new ModelChoice({
                name: "Anthracite",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-anthracite.png"
            }),
            ivory: new ModelChoice({
                name: "Ivory",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-ivory.jpeg"
            }),
            dust_grey: new ModelChoice({
                name: "Dust Grey",
                img_src: "/img/browse/option/clicbox-colour/clicbox-colour-dust-grey.png"
            }),
        }
        let choiceOrder;

        if (variationIDs.solution_id === "bedroom_flat_pack") {
            choiceOrder = ['urban_oak', 'white', 'grey'];
        } else {
            choiceOrder = ['white', 'urban_oak', 'grey', 'dust_grey', 'anthracite'];
        }

        return {
            name: "Cabinet Colour",
            choices: choices,
            choice_order: choiceOrder,
            required: true,
            default_choice_id: "white"
        }

    }

    function getHingeColourValues(model, variationIDs) {

        const choices = {
            silver: new ModelChoice({
                name: "Hettich Silver",
                img_src: "/img/browse/option/hinge-colour/hinge-colour-silver.jpg"
            }),

            black: new ModelChoice({
                name: "Hettich Black",
                img_src: "/img/browse/option/hinge-colour/hinge-colour-black.jpg"
            })
        }

        if (variationIDs.browse_id === "solution" || (variationIDs.browse_id === "component" && variationIDs.solution_id)) {
            choices.silver.name = "Silver";
            choices.black.name = "Black";
        }

        const choiceOrder = ['silver', 'black'];

        return {
            name: "Hinge Colour",
            choices: choices,
            choice_order: choiceOrder,
            required: true,
            default_choice_id: "silver"
        };
    }

    function getHingeOptionValues(model, variationIDs) {

        let choiceOrder;

        if (variationIDs.door_type_id === "bifold") {
            choiceOrder = ['pto'];
        } else {
            choiceOrder = ['sc', 'pto'];
        }

        return {
            name: "Hinge Option",
            choices: {
                sc: new ModelChoice({
                    name: "Soft Close",
                    img_src: "/img/browse/option/hinge-option/hinge-option-soft-close.png"
                }),
                pto: new ModelChoice({
                    name: "Push to Open",
                    img_src: "/img/browse/option/hinge-option/hinge-option-push-to-open.png"
                })
            },
            choice_order: choiceOrder,
            required: true,
            default_choice_id: "sc",

            applyInitState: function (product) {
                this.super(product);
                if (variationIDs.base_component_id === "hettich") {
                    model.name = "Choose your open option";
                }
            }
        };
    }

    function getDrawerColourValues(model, variationIDs) {
        const choiceOrder = ['silver', 'graphite'];
        return {
            name: "Drawer Colour",
            bar_name: "Drawers",
            error_message: "You must select a drawer colour.",
            choices: {
                silver: new ModelChoice({
                    name: "Silver",
                    img_src: "/img/browse/option/drawer-colour/drawer-colour-silver.jpg",
                    descriptive_name: "Colour: Silver",
                    img_name: "Clicbox Drawers Silver"
                }),

                graphite: new ModelChoice({
                    name: "Graphite",
                    img_src: "/img/browse/option/drawer-colour/drawer-colour-graphite.jpg",
                    descriptive_name: "Colour: Graphite",
                    img_name: "Clicbox Drawers Graphite"
                }),
                emuca_silver: new ModelChoice({
                    name: "Silver",
                    img_src: "/img/browse/option/drawer-colour/drawer-colour-silver.jpg",
                    descriptive_name: "Colour: Silver",
                    img_name: "Clicbox Drawers Emuca Silver"
                })
            },
            choice_order: choiceOrder,
            required: true,
            default_choice_id: "silver"
        };

    }

    function getHettichColourValues(model, variationIDs) {

        return {
            error_message: "You must select a colour.",
            name: "Choose your colour",
            choices: {
                silver: new ModelChoice({
                    name: "Silver",
                    img_src: "/img/browse/option/hettich-colour/hettich-colour-silver.png"
                }),

                graphite: new ModelChoice({
                    name: "Graphite",
                    img_src: "/img/browse/option/hettich-colour/hettich-colour-graphite.png"
                }),

                black: new ModelChoice({
                    name: "Black",
                    img_src: "/img/browse/option/hettich-colour/hettich-colour-black.png"
                }),
            },
            choice_order: ['silver', 'graphite', 'black'],
            applyInitState: function (product) {
                this.super(product);
                if (product) {
                    const choiceOrder = [];
                    if (product.colours) {
                        for (let i = 0; i < product.colours.length; i++) {
                            const colourID = product.colours[i];
                            if (model.choices[colourID]) {
                                choiceOrder.push(colourID);
                            }
                        }
                    }
                    model.choice_order = choiceOrder;
                    model.choices = siteHelper.filterChoices(model.choices, model.choice_order);
                }
            }
        };
    }

    function getSelectedDoorOptionValues(model, variationIDs) {

        return {
            name: "Door Options",
            prevent_deselect: true,
            choices: {
                door: new ModelChoice({
                    name: "Door",
                    img_class: "match-door-option",
                    getImgSrc: function () {
                        const stateIDs = $rootScope.navigation_model.state_ids;
                        return $rootScope.service.image.getStyleImgSrc(stateIDs.site_range_id, stateIDs.colour_id, stateIDs.style_id);
                    }
                }),

                unglazed_frame: new ModelChoice({
                    name: "Unglazed Frame",
                    hidden: true,
                    img_src: "/img/browse/option/door-option/door-option-unglazed-frame.jpg"
                }),
                glazed_door: new ModelChoice({
                    name: "Glazed Door",
                    hidden: true,
                    img_src: "/img/browse/option/door-option/door-option-glazed-door.jpg"
                }),
                square_door: new ModelChoice({
                    name: "Square Door",
                    hidden: true,
                    img_src: "/img/browse/option/door-option/door-option-door.jpg"
                })
            },
            choice_order: ['door', 'unglazed_frame', 'glazed_door', 'square_door'],

            applyCurrentState: function (product) {
                if (product) {

                    const findAvailableDoorOptions = product.find_available_door_options;
                    product.find_available_door_options = false;
                    const productData = product.height && product.width && product.valid_product_data[product.height] ? product.valid_product_data[product.height][product.width] : null;

                    const previousID = product.option_term_ids[model.option_id];
                    let currentID = previousID;
                    let count = 0;
                    for (let choiceID in model.choices) {
                        const choice = model.choices[choiceID];
                        if (choiceID === "door") {
                            if (product.height && product.height < 283) {
                                choice.name = "Drawer";
                            } else {
                                choice.name = "Door";
                            }
                        } else {
                            const valid = !!productData && !!productData[choiceID];
                            if (!valid && previousID === choiceID) {
                                currentID = "door";
                            }
                            choice.disabled = !valid;
                            if (findAvailableDoorOptions) {
                                choice.hidden = !valid;
                            }
                        }
                        if(!choice.hidden){
                            count ++;
                        }
                    }
                    model.hidden = count < 2;
                    if (currentID !== previousID) {

                        product.option_term_ids[model.option_id] = currentID;
                        return true;
                    }
                }
                return false;
            }
        };
    }

    function getHandleStyleValues(model, variationIDs) {

        return {
            choices: {
                door: new ModelChoice({
                    name: "Standard",
                    img_src: "/img/browse/option/handle-style/handle-style-standard.png",
                    choose_name: "For Standard Handles",
                    note: ""
                }),
                inset: new ModelChoice({
                    name: "Inset",
                    img_src: "/img/browse/option/handle-style/handle-style-inset.png",
                    choose_name: "Inset Handle",
                    note: "Default position only available"
                })
            },
            choice_order: ['door', 'inset']
        };
    }

    function getEdgeOptionValues(model, variationIDs) {

        const siteRangeID = variationIDs.site_range_id;
        const colourID = variationIDs.colour_id;

        const cache_colours = $rootScope.model.cache_local_server.colour.site_range[siteRangeID];
        const cache_colour = cache_colours ? cache_colours.choices[colourID] : null;
        if (!cache_colour || !cache_colour.has_edge_option) {
            return null
        }

        const choiceOrder = ['matching', 'plywood', 'glass', 'brushed_steel'];


        return {
            name: "Edge Option",
            error_message: "You must select a valid edge option.",
            choices: {
                matching: new ModelChoice({
                    name: "Matching",
                    img_src: "/img/browse/option/edge-option/edge-option-matching.png",
                    narratives: ["MATCH-EDG", "INTER HANDLE MATCH-EDG"]
                }),
                plywood: new ModelChoice({
                    name: "Plywood",
                    img_src: "/img/browse/option/edge-option/edge-option-plywood.png",
                    narratives: ["PLYWOOD-EDG", "PLYWOOD-EDGE"]
                }),
                glass: new ModelChoice({
                    name: "Glass",
                    img_src: "/img/browse/option/edge-option/edge-option-glass.png",
                    narratives: ["GLASS-EDG", "INTER HANDLE GLASS-EDGE"],
                    disabled: !cache_colour.has_edge_option_glass
                }),
                brushed_steel: new ModelChoice({
                    name: "Brushed Steel",
                    img_src: "/img/browse/option/edge-option/edge-option-brushed-steel.png",
                    narratives: ["INTER HANDLE BSTEEL-EDG"]
                })
            },
            choice_order: choiceOrder
        };
    }

    function getHandleShapeInsetValues(model, variationIDs) {
        if (variationIDs.parent_category_id !== "door_inset" && variationIDs.parent_category_id !== "frame_open_inset") {
            return null;
        }

        return {
            name: "Inset Handle",
            error_message: "You must select an Inset Handle.",
            choices: {
                standard: new ModelChoice({
                    name: "Standard Handle",
                    narratives: ["STD INSET HANDLE"],
                    img_src: "/img/browse/option/handle-shape/handle-shape-inset-curved-330.jpg"
                }),
                curved_138: new ModelChoice({
                    name: "138 Inset Curved Handle",
                    narratives: ["138 INSET HANDLE"],
                    img_src: "/img/browse/option/handle-shape/handle-shape-inset-curved-138.jpg",
                }),
                curved_234: new ModelChoice({
                    name: "234 Inset Curved Handle",
                    narratives: ["234 INSET HANDLE"],
                    img_src: "/img/browse/option/handle-shape/handle-shape-inset-curved-234.jpg",
                }),
                curved_330: new ModelChoice({
                    name: "330 Inset Curved Handle",
                    narratives: ["330 INSET HANDLE"],
                    img_src: "/img/browse/option/handle-shape/handle-shape-inset-curved-330.jpg",
                }),
                curved_426: new ModelChoice({
                    name: "426 Inset Curved Handle",
                    narratives: ["426 INSET HANDLE"],
                    img_src: "/img/browse/option/handle-shape/handle-shape-inset-curved-426.jpg",
                }),
                curved_620: new ModelChoice({
                    name: "620 Inset Curved Handle",
                    narratives: ["620 INSET HANDLE"],
                    img_src: "/img/browse/option/handle-shape/handle-shape-inset-curved-620.jpg",
                }),
                curved_820: new ModelChoice({
                    name: "820 Inset Curved Handle",
                    narratives: ["820 INSET HANDLE"],
                    img_src: "/img/browse/option/handle-shape/handle-shape-inset-curved-820.jpg",
                }),
                no_handle: new ModelChoice({
                    name: "No Handle",
                    narratives: ["NOHANDLE"],
                    img_src: "/img/browse/option/no-image.jpg",
                    hidden: true
                })
            },
            choice_order: ['standard', 'curved_138', 'curved_234', 'curved_330', 'curved_426', 'curved_620', 'curved_820', 'no_handle']
        };
    }

    function getHandlePositionValues(model, variationIDs) {
        const styleID = variationIDs.style_id;
        const parentCategoryID = variationIDs.parent_category_id;
        if (
            parentCategoryID === "door_inset" ||
            parentCategoryID === "frame_open_inset" ||
            styleID === "segreto" ||
            styleID === "integra" ||
            styleID === "integra_full_handle" ||
            styleID === "knebworth" ||
            styleID === "elland"
        ) {
            return null;
        }

        return {
            name: "Handle Position",
            error_message: "You must select a Handle position.",
            details: {},
            choices: {
                standard: new ModelChoice({
                    name: "Standard Position",
                    narratives: ["STD-POS"],
                    img_src: "/img/browse/option/handle-position/handle-position-inset-top.png"
                }),
                handle_top: new ModelChoice({
                    name: "Top Position",
                    narratives: ["HT"],
                    img_src: "/img/browse/option/handle-position/handle-position-inset-top.png"
                }),

                handle_bottom: new ModelChoice({
                    name: "Bottom Position",
                    narratives: ["HB"],
                    img_src: "/img/browse/option/handle-position/handle-position-inset-bottom.png"
                }),
                horizontal: new ModelChoice({
                    name: "Horizontal Position",
                    narratives: ["HORIZ-POS"],
                    img_src: "/img/browse/option/handle-position/handle-position-inset-horizontal.png"
                }),
                no_handle: new ModelChoice({
                    name: "No Handle",
                    narratives: ["NOHANDLE"],
                    img_src: "/img/browse/option/handle-position/handle-position-inset-none.png"
                })
            },
            choice_order: ['standard', 'handle_top', 'handle_bottom', 'horizontal', 'no_handle'],
            input_section_list: [
                {
                    id: "handle_offset_section",
                    details: {
                        //messages: ["Please select Handle distance from top"],
                    },
                    input_list: [
                        {
                            type: 'number',
                            id: 'handle_offset',
                            name: 'Handle distance from the top (D)',
                            required: true,
                            explanation: 'mm',
                            required_error: 'Handle distance from the top (D) not specified'
                        },
                    ]
                }

            ],
            applyCurrentState: function (product) {
                if (!product) {
                    return false;
                }
                const previousID = product.option_term_ids[model.option_id];
                let currentID;

                if (product.width && product.width < 240) {
                    model.disabled = true;
                    model.details.note = "Handles are not available for doors under 240mm width.";
                    currentID = "no_handle";
                } else {
                    model.disabled = false;
                    model.details.note = null;
                    currentID = previousID;
                }
                product.option_term_ids[model.option_id] = currentID;
                for (let i = 0; i < model.input_section_list.length; i++) {
                    const inputSection = model.input_section_list[i];
                    if (inputSection.id === "handle_offset_section") {
                        inputSection.was_hidden = inputSection.hidden;
                        inputSection.hidden = currentID !== "horizontal";
                        break;
                    }
                }
                handleVisibilityChange(model, product);
                return currentID !== previousID;
            }
        };
    }

    function getHandlePositionInsetValues(model, variationIDs) {
        if (variationIDs.parent_category_id !== "door_inset" && variationIDs.parent_category_id !== "frame_open_inset") {
            return null;
        }

        return {
            name: "Position",
            error_message: "You must select an Inset Handle position.",
            choices: {
                standard: new ModelChoice({
                    name: "Standard Position",
                    narratives: ["STD-POS"],
                    img_src: "/img/browse/option/handle-position/handle-position-inset-top.png"
                }),
                horizontal: new ModelChoice({
                    name: "Horizontal Position",
                    narratives: ["HOR-POS"],
                    img_src: "/img/browse/option/handle-position/handle-position-inset-horizontal.png",
                }),
                left: new ModelChoice({
                    name: "Left Position",
                    narratives: ["L-POS"],
                    img_src: "/img/browse/option/handle-position/handle-position-inset-left.png",
                }),
                right: new ModelChoice({
                    name: "Right Position",
                    narratives: ["R-POS"],
                    img_src: "/img/browse/option/handle-position/handle-position-inset-right.png",
                }),
                bottom: new ModelChoice({
                    name: "Bottom Position",
                    narratives: ["B-POS"],
                    img_src: "/img/browse/option/handle-position/handle-position-inset-bottom.png",
                    hidden: true
                })
            },
            choice_order: ['standard', 'horizontal', 'left', 'right', 'bottom'],

            input_section_list: [
                {
                    id: "inset_offset_section",
                    details: {
                        //messages: ["Please select Handle distance from top"],
                    },
                    input_list: [
                        {
                            type: 'number',
                            id: 'inset_offset',
                            name: 'Handle distance from the top (D)',
                            required: true,
                            explanation: 'mm',
                            required_error: 'Handle distance from the top (D) not specified'
                        },
                    ]
                }
            ],
            applyCurrentState: function (product) {
                if (!product) {
                    return false;
                }
                const currentID = product.option_term_ids[model.option_id];
                for (let i = 0; i < model.input_section_list.length; i++) {
                    const inputSection = model.input_section_list[i];
                    if (inputSection.id === "inset_offset_section") {
                        inputSection.was_hidden = inputSection.hidden;
                        inputSection.hidden = currentID === "standard";
                        break;
                    }
                }
                handleVisibilityChange(model, product);
                return false;
            }
        };
    }

    function getHandlePositionSegretoValues(model, variationIDs) {
        if (variationIDs.style_id !== "segreto") {
            return null;
        }

        return {
            name: "Segreto Handle",
            error_message: "You must select a Segreto Handle.",
            choices: {
                top: new ModelChoice({
                    name: "Handle Top",
                    narratives: ["HT"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-top.png"
                }),
                bottom: new ModelChoice({
                    name: "Handle Bottom",
                    narratives: ["HB"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-bottom.png"
                }),
                left: new ModelChoice({
                    name: "Handle Left",
                    narratives: ["HL"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-left.png"
                }),
                right: new ModelChoice({
                    name: "Handle Right",
                    narratives: ["HR"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-right.png"
                }),
                top_left: new ModelChoice({
                    name: "Handle Top Left",
                    narratives: ["HTL"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-top-left.png"
                }),
                top_right: new ModelChoice({
                    name: "Handle Top Right",
                    narratives: ["HTR"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-top-right.png"
                }),
                bottom_left: new ModelChoice({
                    name: "Handle Bottom Left",
                    narratives: ["HBL"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-bottom-left.png"
                }),
                bottom_right: new ModelChoice({
                    name: "Handle Bottom Right",
                    narratives: ["HBR"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-bottom-right.png"
                }),
                top_centre: new ModelChoice({
                    name: "Handle Top Centre",
                    narratives: ["HTC"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-top-centre.png"
                }),
                bottom_centre: new ModelChoice({
                    name: "Handle Bottom Centre",
                    narratives: ["HBC"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-bottom-centre.png"
                }),
                twin_top: new ModelChoice({
                    name: "Twin Handle Top",
                    narratives: ["2HT"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-twin-top.png"
                }),
                twin_bottom: new ModelChoice({
                    name: "Twin Handle Bottom",
                    narratives: ["2HB"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-twin-bottom.png"
                }),
                top_left_vertical: new ModelChoice({
                    name: "Handle Top Left Vertical",
                    narratives: ["HTLV", "HLTV"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-top-left-vertical.png"
                }),
                top_right_vertical: new ModelChoice({
                    name: "Handle Top Right Vertical",
                    narratives: ["HTRV", "HRTV"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-top-right-vertical.png"
                }),
                bottom_left_vertical: new ModelChoice({
                    name: "Handle Bottom Left Vertical",
                    narratives: ["HBLV", "HLBV"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-bottom-left-vertical.png"
                }),
                bottom_right_vertical: new ModelChoice({
                    name: "Handle Bottom Right Vertical",
                    narratives: ["HBRV", "HRBV"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-bottom-right-vertical.png"
                }),
                left_centre_vertical: new ModelChoice({
                    name: "Handle Left Centre Vertical",
                    narratives: ["HLCV"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-left-centre-vertical.png"
                }),
                right_centre_vertical: new ModelChoice({
                    name: "Handle Right Centre Vertical",
                    narratives: ["HRCV"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-right-centre-vertical.png"
                }),
                twin_left_vertical: new ModelChoice({
                    name: "Twin Handle Left Vertical",
                    narratives: ["2HLV"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-twin-left-vertical.png"
                }),
                twin_right_vertical: new ModelChoice({
                    name: "Twin Handle Right Vertical",
                    narratives: ["2HRV"],
                    img_src: "/img/browse/option/handle-position/handle-position-segreto-twin-right-vertical.png"
                })
            },
            choice_order: [
                'top', 'bottom', 'left', 'right', 'top_left', 'top_right', 'bottom_left', 'bottom_right', 'top_centre',
                'bottom_centre', 'twin_top', 'twin_bottom', 'top_left_vertical', 'top_right_vertical',
                'bottom_left_vertical', 'bottom_right_vertical', 'left_centre_vertical', 'right_centre_vertical',
                'twin_left_vertical', 'twin_right_vertical']
        };
    }

    function getHandlePositionIntegraValues(model, variationIDs) {
        if (variationIDs.style_id !== "integra" && variationIDs.style_id !== "integra_full_handle") {
            return null;
        }

        const details = {
            messages: []
        }

        let choiceOrder;
        if (variationIDs.style_id === "integra") {
            choiceOrder = ['top', 'bottom_left', 'bottom_right', 'bottom'];
            details.messages.push(
                "Handle groove on drawer fronts and doors > 1699 high have a 200mm long groove on the top. " +
                "Doors 1700 > high have a 900mm long groove on the L/R side."
            )
        } else {
            choiceOrder = ['top', 'left', 'right', 'bottom'];
        }

        return {
            name: "Integra Handle",
            details: details,
            error_message: "You must select an Integra Handle.",
            choices: {
                top: new ModelChoice({
                    name: "Top Handle",
                    img_src: "/img/browse/option/handle-position/handle-position-integra-top.png"
                }),
                left: new ModelChoice({
                    name: "Left Handle",
                    img_src: "/img/browse/option/handle-position/handle-position-integra-full-left.png"
                }),
                right: new ModelChoice({
                    name: "Right Handle",
                    img_src: "/img/browse/option/handle-position/handle-position-integra-full-right.png"
                }),
                bottom_left: new ModelChoice({
                    name: "Bottom Left Handle",
                    img_src: "/img/browse/option/handle-position/handle-position-integra-bottom-left.png"
                }),
                bottom_right: new ModelChoice({
                    name: "Bottom Right Handle",
                    img_src: "/img/browse/option/handle-position/handle-position-integra-bottom-right.png"
                }),
                bottom: new ModelChoice({
                    name: "Bottom Handle",
                    img_src: "/img/browse/option/handle-position/handle-position-integra-bottom.png"
                })
            },
            choice_order: choiceOrder
        };
    }

    function getHandlePositionKnebworthValues(model, variationIDs) {
        const styleID = variationIDs.style_id;
        if (styleID !== "knebworth" && styleID !== "elland" && styleID !== "chelsea") {
            return null;
        }

        let name;
        if (styleID === "elland") {
            name = "Elland Handle";
        } else if (styleID === "chelsea") {
            name = "Chelsea Handle";
        } else {
            name = "Knebworth Handle";
        }
        let choiceOrder;
        if (styleID === "chelsea") {
            if(["door_sloping", "door_sloping_calculator"].includes(variationIDs.parent_category_id)) {

                choiceOrder = ['left', 'right'];
            } else {

                choiceOrder = ['top', 'left', 'right', 'bottom'];
            }
        } else {
            choiceOrder = ['top', 'left', 'right', 'bottom', 'top_left', 'top_right', 'bottom_left', 'bottom_right'];
        }

        return {
            name: name,
            details: {
                messages: [
                    "Handle groove runs horizontal on drawer fronts and on doors < 1245 high. Doors 1246 > " +
                    "the handle groove runs vertical.",
                    "Available with a left or right hand stopped handle groove option as shown. The handle groove is " +
                    "200mm long."
                ]
            },
            error_message: "You must select an Handle.",
            choices: {
                top: new ModelChoice({
                    name: "Top Position",
                    img_src: "/img/browse/option/handle-position/handle-position-knebworth-top.png"
                }),
                left: new ModelChoice({
                    name: "Left Position",
                    img_src: "/img/browse/option/handle-position/handle-position-knebworth-left.png"
                }),
                right: new ModelChoice({
                    name: "Right Position",
                    img_src: "/img/browse/option/handle-position/handle-position-knebworth-right.png"
                }),
                bottom: new ModelChoice({
                    name: "Bottom Position",
                    img_src: "/img/browse/option/handle-position/handle-position-knebworth-bottom.png"
                }),
                top_left: new ModelChoice({
                    name: "top Left Position",
                    img_src: "/img/browse/option/handle-position/handle-position-knebworth-stopped-top-left.png"
                }),
                top_right: new ModelChoice({
                    name: "Top Right Position",
                    img_src: "/img/browse/option/handle-position/handle-position-knebworth-stopped-top-right.png"
                }),
                bottom_left: new ModelChoice({
                    name: "Bottom Left Position",
                    img_src: "/img/browse/option/handle-position/handle-position-knebworth-stopped-bottom-left.png"
                }),
                bottom_right: new ModelChoice({
                    name: "Bottom Right Position",
                    img_src: "/img/browse/option/handle-position/handle-position-knebworth-stopped-bottom-right.png"
                })
            },
            choice_order: choiceOrder,

            applyInitState: function (product) {
                this.super(product);
                if (styleID === "elland") {
                    if (product && product.type === "open_frame") {
                        model.choice_order = ['top', 'left', 'right', 'bottom'];
                        model.choices = siteHelper.filterChoices(model.choices, model.choice_order);
                        model.details.messages = [
                            "Handle groove runs horizontal on drawer fronts and on doors < 1245 high. Doors 1246 > " +
                            "the handle groove runs vertical."
                        ]
                    }
                }
            }
        };
    }

    function getHandleColourValues(model, variationIDs) {
        const siteRangeID = variationIDs.site_range_id;
        const styleID = variationIDs.style_id;

        const cacheStyles = $rootScope.model.cache_local_server.style.site_range[siteRangeID];
        const cacheStyle = cacheStyles ? cacheStyles.choices[styleID] : null;
        if (!cacheStyle || !cacheStyle.available_handle_colours) {
            return null
        }

        let name, barName, errorMessage;

        let required = false;
        if (variationIDs.browse_id === "solution" || (variationIDs.browse_id === "component" && variationIDs.solution_id)) {
            required = true
        }

        const choices = {
            copper: new ModelChoice({
                name: "Copper",
                img_src: "/img/browse/option/handle-colour/handle-colour-lazio-copper.jpg"
            }),

            matt_black: new ModelChoice({
                name: "Matt Black",
                img_src: "/img/browse/option/handle-colour/handle-colour-lazio-black.jpg"
            }),

            matt_white: new ModelChoice({
                name: "Matt White",
                img_src: "/img/browse/option/handle-colour/handle-colour-lazio-white.jpg"
            }),

            satin_chrome: new ModelChoice({
                name: "Satin Chrome",
                img_src: "/img/browse/option/handle-colour/handle-colour-lazio-satin-chrome.jpg"
            }),
            brushed_steel: new ModelChoice({
                name: "Dark Brushed Steel",
                img_src: "/img/browse/option/handle-colour/handle-colour-segreto-steel.png"
            }),

            brushed_nickel: new ModelChoice({
                name: "Brushed Nickel",
                img_src: "/img/browse/option/handle-colour/handle-colour-segreto-nickel.png"
            }),

            black: new ModelChoice({
                name: "Black",
                img_src: "/img/browse/option/handle-colour/handle-colour-segreto-black.png"
            })
        }
        const choiceOrder = ['satin_chrome', 'brushed_steel', 'brushed_nickel'];
        for (let i = 0; i < choiceOrder.length; i++) {
            if (!cacheStyle.available_handle_colours[choiceOrder[i]]) {
                choiceOrder.splice(i, 1);
                i--;
            }
        }

        if (variationIDs.style_id === "lazio") {
            name = "Lazio Handle Colour";
            barName = "Lazio Handle";
            errorMessage = "You must select a Lazio Handle Colour.";
        } else if (variationIDs.style_id === "segreto") {
            name = "Segreto Handle Colour";
            barName = "Segreto Handle";
            errorMessage = "You must select a Segreto Handle Colour.";
        }

        return {
            name: name,
            bar_name: barName,
            required: required,
            error_message: errorMessage,
            choices: choices,
            choice_order: choiceOrder,

            applyCurrentState: function (product) {
                if (!product) {
                    return false;
                }
                const previousID = product.option_term_ids[model.option_id];
                let currentID = previousID;
                if (product.width && product.width < 240) {
                    currentID = null;
                    model.hidden = true;
                } else {
                    model.hidden = false;
                }
                product.option_term_ids[model.option_id] = currentID;
                return currentID !== previousID;
            },
        };
    }

    function getMidrailValues(model, variationIDs) {

        return {
            name: "Mid Rail",
            details: {
                messages: [
                    "Tall doors with 2 panels will be supplied with the mid rail at 655mm from the bottom edge to the " +
                    "centre of the mid rail as standard unless otherwise specified."
                ]
            },
            error_message: "Please select a midrail option!'",
            choices: {
                midrail_no: new ModelChoice({
                    name: "No Mid Rail",
                    narratives: ["NO MIDRAIL"],
                    img_src: "/img/browse/option/midrail/midrail-no.png"
                }),
                midrail_yes: new ModelChoice({
                    name: "Mid Rail",
                    narratives: ["MID RAIL"],
                    img_src: "/img/browse/option/midrail/midrail-yes.png"
                })
            },
            choice_order: ['midrail_no', 'midrail_yes'],
            input_section_list: [
                {
                    id: "midrail_height_section",
                    input_list: [
                        {
                            type: 'number',
                            id: 'midrail_height',
                            name: 'Rail Height (MID)',
                            min: 300,
                            default_value: 655,
                            required: true,
                            explanation: '300mm and above',
                            required_error: 'Mid Rail height not specified'
                        },
                    ]
                }

            ],
            applyCurrentState: function (product) {
                if (!product) {
                    return false;
                }
                const currentID = product.option_term_ids[model.option_id];
                model.was_hidden = model.hidden;
                model.hidden = true;
                if ($rootScope.navigation_model.state_values.style_midrail) {
                    if (product.height >= 655) {
                        model.hidden = false;
                        for (let i = 0; i < model.input_section_list.length; i++) {
                            const inputSection = model.input_section_list[i];
                            if (inputSection.id === "midrail_height_section") {
                                inputSection.was_hidden = inputSection.hidden;
                                inputSection.hidden = currentID !== "midrail_yes";
                                if (!inputSection.hidden) {
                                    for (let j = 0; j < inputSection.input_list.length; j++) {
                                        const input = inputSection.input_list[j];
                                        if (input.id === "midrail_height") {
                                            input.max = product.maximum_height
                                            break;
                                        }
                                    }
                                }
                                break;
                            }
                        }
                    }
                }
                handleVisibilityChange(model, product)
                return false;
            },
        };
    }

    function getFrameTypeValues(model, variationIDs) {

        return {
            name: "Frame Type",
            error_message: "You must select a valid frame type.",
            choices: {
                open: new ModelChoice({
                    name: "Open Frame",
                    narratives: ["OPEN FRAME"],
                    img_src: "/img/browse/option/frame-type/frame-type-open.jpg"
                }),

                open_full: new ModelChoice({
                    name: "Full Open Frame",
                    narratives: ["FULL OPEN FRAME"],
                    img_src: "/img/browse/option/frame-type/frame-type-open-full.jpg"
                }),
                open_top: new ModelChoice({
                    name: "Top Open Frame",
                    narratives: ["TOP OPEN FRAME"],
                    img_src: "/img/browse/option/frame-type/frame-type-open-top.jpg",
                    has_midrail: true
                }),
                open_top_bottom: new ModelChoice({
                    name: "T&b Open Frame",
                    narratives: ["TOP + BOTTOM OPEN FR"],
                    img_src: "/img/browse/option/frame-type/frame-type-open-top-bottom.jpg",
                    has_midrail: true
                })
            },
            choice_order: ['open', 'open_full', 'open_top', 'open_top_bottom'],

            applyInitState: function (product) {
                this.super(product);
                for (let choiceID in model.choices) {
                    const choice = model.choices[choiceID];
                    const complexOption = model.complexOptionTermChoice(choiceID, product, true);
                    if (complexOption) {
                        let name = choice.name;
                        if (complexOption.minimum_height) {
                            name = name + " H >= " + complexOption.minimum_height + "mm"
                        }
                        if (complexOption.maximum_height) {
                            name = name + " H <= " + complexOption.maximum_height + "mm"
                        }
                        choice.name = name;
                    }
                }
            },
            applyCurrentState: function (product) {
                if (!product) {
                    return false;
                }

                const previousID = product.option_term_ids[model.option_id];
                let currentID = previousID;
                let hasMidrail = false;
                for (let choiceID in model.choices) {
                    const choice = model.choices[choiceID];
                    const complexOption = model.complexOptionTermChoice(choiceID, product, true);
                    if (complexOption) {
                        let disabled = true;
                        if (product.height) {
                            disabled = (complexOption.minimum_height && product.height < complexOption.minimum_height) ||
                                (complexOption.maximum_height && product.height > complexOption.maximum_height);
                        }
                        choice.disabled = disabled;
                        if (previousID === complexOption.choice_id) {
                            if (choice.has_midrail) {
                                hasMidrail = true;
                            }
                            if (disabled) {
                                currentID = null
                            }
                        }
                    }
                }

                if (product.selection_inputs.midrail) {
                    product.selection_inputs.midrail.disabled = !hasMidrail;
                }
                product.option_term_ids[model.option_id] = currentID;
                return currentID !== previousID;
            }
        };

    }

    function getGlazingValues(model, variationIDs) {

        return {
            name: "Glass Fixing Options & Glazing",
            error_message: "You must select a Glass Fixing Option or Glazing.",
            choices: {
                clips: new ModelChoice({
                    name: "Clips",
                    narratives: ["CLIPS"],
                    img_src: "/img/browse/option/glass-fixing/glass-fixing-clips.jpg"
                }),

                rubber_seal: new ModelChoice({
                    name: "Rubber Seal",
                    narratives: ["REBATED WITH SEAL", "REBATED WITH RUBBER SEAL"],
                    img_src: "/img/browse/option/glass-fixing/glass-fixing-rubber-seal.jpg"
                }),

                clear: new ModelChoice({
                    name: "Clear",
                    narratives: ["CLEAR GLAZING"],
                    img_src: "/img/browse/option/glass-fixing/glass-fixing-clear.jpg"
                }),

                frosted: new ModelChoice({
                    name: "Frosted",
                    narratives: ["FROSTED GLAZING"],
                    img_src: "/img/browse/option/glass-fixing/glass-fixing-frosted.jpg",
                    hidden: true,
                }),

                stippled: new ModelChoice({
                    name: "Stippled",
                    narratives: ["STIPPLED GLAZING"],
                    img_src: "/img/browse/option/glass-fixing/glass-fixing-stippled.jpg",
                    hidden: true,
                })
            },
            choice_order: ['clips', 'rubber_seal', 'clear']
        };
    }

    function getOverhangValues(model, variationIDs) {

        return {
            name: "Overhang Door Option",
            details: {
                messages: [
                    "Use extended length doors on wall cabinets to create a handleless effect. The oversized doors  " +
                    "overhang the bottom of the cabinet by 18mm."
                ]
            },
            can_collapse_messages: true,
            is_messages_collapsed: true,
            choices: {
                overhang_no: new ModelChoice({
                    name: "Standard",
                    img_src: "/img/browse/option/overhang/overhang-no.png"
                }),
                overhang_yes: new ModelChoice({
                    name: "Overhang",
                    img_src: "/img/browse/option/overhang/overhang-yes.png"
                })
            },
            choice_order: ['overhang_no', 'overhang_yes'],
            applyInitState: function (product) {
                this.super(product);
                const overhang_colour_exceptions = product ? product.overhang_colour_exceptions : null;
                if (overhang_colour_exceptions) {
                    const colourID = $rootScope.navigation_model.state_ids.colour_id;
                    if (colourID && overhang_colour_exceptions[colourID]) {
                        model.hidden = true;
                    }
                }
            }
        };
    }

    function getInternalValues(model, variationIDs) {

        return {
            name: "Internals",
            error_message: "You must select your internal",
            collapse_messages_txt: "Add Internals +",
            always_visible: true,
            details: {
                messages: [],
            },
            choices: {
                none: new ModelChoice({
                    name: "No Internal",
                    img_src: "/img/browse/option/no-image.jpg"
                }),
                standard: new ModelChoice({
                    name: "Single Hanging",
                    img_src: "/img/browse/option/internal/internal-double-single-hanging.png",
                    single: {
                        img_src: "/img/browse/option/internal/internal-single-single-hanging.png",
                    }
                }),
                shelves: new ModelChoice({
                    name: "Shelves",
                    img_src: "/img/browse/option/internal/internal-double-shelves.png",
                    single: {
                        img_src: "/img/browse/option/internal/internal-single-shelves.png",
                    }
                }),
                split_hanging: new ModelChoice({
                    name: "Split Hanging",
                    img_src: "/img/browse/option/internal/internal-double-split-hanging.png",
                    single: {
                        img_src: "/img/browse/option/internal/internal-single-split-hanging.png",
                    }
                }),
                fitment: new ModelChoice({
                    name: "Fitment",
                    img_src: "/img/browse/option/internal/internal-double-fitment.png"
                }),
                chest: new ModelChoice({
                    name: "Chest",
                    img_src: "/img/browse/option/internal/internal-double-chest.jpg"
                }),
                pull_out_150: new ModelChoice({
                    name: "Pull Out",
                    img_src: "/img/browse/option/internal/internal-pull-out-150.jpg"
                }),
                pull_out_300: new ModelChoice({
                    name: "Pull Out",
                    img_src: "/img/browse/option/internal/internal-pull-out-300.jpg"
                }),
                pull_out_300_larder: new ModelChoice({
                    name: "Pull Out",
                    img_src: "/img/browse/option/internal/internal-pull-out-300-larder.jpg"
                }),
                cargo_300: new ModelChoice({
                    name: "Pull out Cargo Bin",
                    img_src: "/img/browse/option/internal/internal-cargo-300.jpg",
                }),
                cargo_400: new ModelChoice({
                    name: "Pull out Cargo Bin",
                    img_src: "/img/browse/option/internal/internal-cargo-400.jpg",
                }),
                cargo_500: new ModelChoice({
                    name: "Pull out Cargo Bin",
                    img_src: "/img/browse/option/internal/internal-cargo-500.jpg",
                }),
                cargo_600: new ModelChoice({
                    name: "Pull out Cargo Bin",
                    img_src: "/img/browse/option/internal/internal-cargo-600.jpg",
                }),
                undersink: new ModelChoice({
                    name: "Undersink Storage",
                    img_src: "/img/browse/option/internal/internal-undersink.jpg"
                }),

                cutlery_drawer_500: new ModelChoice({
                    remote_id: "500_cutlery_drawer",
                    name: "Standard Cutlery Tray",
                    img_src: "/img/browse/option/internal/internal-cutlery-drawer.jpeg"
                }),
                cutlery_drawer_600: new ModelChoice({
                    remote_id: "600_cutlery_drawer",
                    name: "Standard Cutlery Tray",
                    img_src: "/img/browse/option/internal/internal-cutlery-drawer.jpeg"
                }),
                cutlery_drawer_800: new ModelChoice({
                    remote_id: "800_cutlery_drawer",
                    name: "Standard Cutlery Tray",
                    img_src: "/img/browse/option/internal/internal-cutlery-drawer.jpeg"
                }),
                cutlery_drawer_900: new ModelChoice({
                    remote_id: "900_cutlery_drawer",
                    name: "Standard Cutlery Tray",
                    img_src: "/img/browse/option/internal/internal-cutlery-drawer.jpeg"
                }),
                cutlery_drawer_1000: new ModelChoice({
                    remote_id: "1000_cutlery_drawer",
                    name: "Standard Cutlery Tray",
                    img_src: "/img/browse/option/internal/internal-cutlery-drawer.jpeg"
                }),
                cutlery_mat_400: new ModelChoice({
                    remote_id: "400_cutlery_mat",
                    name: "Cutlery Tray and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-mat-400.jpeg",
                }),
                cutlery_mat_450: new ModelChoice({
                    remote_id: "450_cutlery_mat",
                    name: "Cutlery Tray and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-mat-450.jpeg",
                }),
                cutlery_mat_500: new ModelChoice({
                    remote_id: "500_cutlery_mat",
                    name: "Cutlery Tray and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-mat-500.jpeg",
                }),
                cutlery_mat_600: new ModelChoice({
                    remote_id: "600_cutlery_mat",
                    name: "Cutlery Tray and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-mat-600.jpg",
                }),
                cutlery_mat_800: new ModelChoice({
                    remote_id: "800_cutlery_mat",
                    name: "Cutlery Tray and Anti-Slip Matting",
                    img_src: "",
                    expected_img_src: "/img/browse/option/internal/internal-cutlery-mat-800.xyz"
                }),
                cutlery_mat_900: new ModelChoice({
                    remote_id: "900_cutlery_mat",
                    name: "Cutlery Tray and Anti-Slip Matting",
                    img_src: "",
                    expected_img_src: "/img/browse/option/internal/internal-cutlery-mat-900.xyz"
                }),
                cutlery_mat_1000: new ModelChoice({
                    remote_id: "1000_cutlery_mat",
                    name: "Cutlery Tray and Anti-Slip Matting",
                    img_src: "",
                    expected_img_src: "/img/browse/option/internal/internal-cutlery-mat-1000.xyz"
                }),
                cutlery_knife_roll_mat_900: new ModelChoice({
                    remote_id: "900_cutlery_knife_roll_mat",
                    name: "Cutlery Tray, Knife Rack, Roll Dispenser, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-knife-roll-mat-900.jpeg",
                }),
                cutlery_knife_spice_roll_mat_1000: new ModelChoice({
                    remote_id: "1000_cutlery_knife_spice_roll_mat",
                    name: "Cutlery Tray, Knife Rack, Spice Rack, Roll Dispenser, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-knife-spice-roll-mat-1000.jpeg"
                }),
                cutlery_knife_spice_mat_1000: new ModelChoice({
                    remote_id: "1000_cutlery_knife_spice_mat",
                    name: "Cutlery Tray, Knife Rack, Spice Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-knife-spice-mat-1000.jpeg",
                }),
                cutlery_knife_mat_400: new ModelChoice({
                    remote_id: "400_cutlery_knife_mat",
                    name: "Cutlery Tray, Knife Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-knife-mat-400.jpg",
                }),
                cutlery_knife_mat_600: new ModelChoice({
                    remote_id: "600_cutlery_knife_mat",
                    name: "Cutlery Tray, Knife Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-knife-mat-600.jpeg",
                }),
                cutlery_knife_mat_800: new ModelChoice({
                    remote_id: "800_cutlery_knife_mat",
                    name: "Cutlery Tray, Knife Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-knife-mat-800.jpeg",
                }),
                cutlery_knife_mat_900: new ModelChoice({
                    remote_id: "900_cutlery_knife_mat",
                    name: "Cutlery Tray, Knife Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-knife-mat-900.jpeg",
                }),
                cutlery_knife_mat_1000: new ModelChoice({
                    remote_id: "1000_cutlery_knife_mat",
                    name: "Cutlery Tray, Knife Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-knife-mat-1000.jpeg",
                }),
                cutlery_spice_roll_mat_800: new ModelChoice({
                    remote_id: "800_cutlery_spice_roll_mat",
                    name: "Cutlery Tray, Spice Rack, Roll Dispenser, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-spice-roll-mat-800.jpeg",
                }),
                cutlery_spice_mat_400: new ModelChoice({
                    remote_id: "400_cutlery_spice_mat",
                    name: "Cutlery Tray, Spice Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-spice-mat-400.jpeg",
                }),
                cutlery_spice_mat_600: new ModelChoice({
                    remote_id: "600_cutlery_spice_mat",
                    name: "Cutlery Tray, Spice Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-spice-mat-600.jpeg",
                }),
                cutlery_spice_mat_800: new ModelChoice({
                    remote_id: "800_cutlery_spice_mat",
                    name: "Cutlery Tray, Spice Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-spice-mat-800.jpeg",
                }),
                cutlery_spice_mat_900: new ModelChoice({
                    remote_id: "900_cutlery_spice_mat",
                    name: "Cutlery Tray, Spice Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-cutlery-spice-mat-900.jpeg",
                }),
                knife_mat_400: new ModelChoice({
                    remote_id: "400_knife_mat",
                    name: "Knife Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-knife-mat-400.jpeg",
                }),
                knife_mat_450: new ModelChoice({
                    remote_id: "450_knife_mat",
                    name: "Knife Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-knife-mat-450.jpeg",
                }),
                knife_mat_500: new ModelChoice({
                    remote_id: "500_knife_mat",
                    name: "Knife Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-knife-mat-500.jpg",
                }),
                knife_mat_800: new ModelChoice({
                    remote_id: "800_knife_mat",
                    name: "Knife Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-knife-mat-800.jpg"
                }),
                knife_mat_900: new ModelChoice({
                    remote_id: "900_knife_mat",
                    name: "Knife Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-knife-mat-900.jpg"
                }),
                knife_mat_1000: new ModelChoice({
                    remote_id: "1000_knife_mat",
                    name: "Knife Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-knife-mat-1000.jpg"
                }),
                knife_roll_mat_500: new ModelChoice({
                    remote_id: "500_knife_roll_mat",
                    name: "Knife Rack, Roll Dispenser, and Anti-Slip Matting ",
                    img_src: "/img/browse/option/internal/internal-knife-roll-mat-500.jpeg",
                }),
                knife_roll_mat_600: new ModelChoice({
                    remote_id: "600_knife_roll_mat",
                    name: "Knife Rack, Roll Dispenser, and Anti-Slip Matting ",
                    img_src: "",
                    expected_img_src: "/img/browse/option/internal/internal-knife-roll-mat-600.xyz"
                }),
                knife_roll_mat_1000: new ModelChoice({
                    remote_id: "1000_knife_roll_mat",
                    name: "Knife Rack, Roll Dispenser, and Anti-Slip Matting ",
                    img_src: "",
                    expected_img_src: "/img/browse/option/internal/internal-knife-roll-mat-1000.xyz"
                }),
                knife_spice_mat_500: new ModelChoice({
                    remote_id: "500_knife_spice_mat",
                    name: "Knife Rack, Spice Rack, and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-knife-spice-mat-500.jpeg",
                }),
                knife_spice_mat_600: new ModelChoice({
                    remote_id: "600_knife_spice_mat",
                    name: "Knife Rack, Spice Rack, and Anti-Slip Matting",
                    img_src: "",
                    expected_img_src: "/img/browse/option/internal/internal-knife-spice-mat-600.xyz"
                }),
                knife_spice_mat_1000: new ModelChoice({
                    remote_id: "1000_knife_spice_mat",
                    name: "Knife Rack, Spice Rack, and Anti-Slip Matting",
                    img_src: "",
                    expected_img_src: "/img/browse/option/internal/internal-knife-spice-mat-1000.xyz"
                }),
                spice_mat_400: new ModelChoice({
                    remote_id: "400_spice_mat",
                    name: "Spice Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-spice-mat-400.jpeg",
                }),
                spice_mat_450: new ModelChoice({
                    remote_id: "450_spice_mat",
                    name: "Spice Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-spice-mat-450.jpeg",
                }),
                spice_mat_500: new ModelChoice({
                    remote_id: "500_spice_mat",
                    name: "Spice Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-spice-mat-500.jpg",
                }),
                spice_mat_800: new ModelChoice({
                    remote_id: "800_spice_mat:",
                    name: "Spice Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-spice-mat-800.jpg"
                }),
                spice_mat_900: new ModelChoice({
                    remote_id: "900_spice_mat:",
                    name: "Spice Rack and Anti-Slip Matting",
                    img_src: "/img/browse/option/internal/internal-spice-mat-900.jpg"
                })/*,
                spice_mat_1000: new ModelChoice({
                    remote_id: "1000_spice_mat",
                    name: "Spice Rack and Anti-Slip Matting",
                    img_src: "",
                })*/
            },

            current_remote_ids: [
                '500_cutlery_drawer',
                '600_cutlery_drawer',
                '800_cutlery_drawer',
                '900_cutlery_drawer',
                '1000_cutlery_drawer',
                '400_cutlery_knife_mat',
                '600_cutlery_knife_mat',
                '800_cutlery_knife_mat',
                '900_cutlery_knife_mat',
                '1000_cutlery_knife_mat',
                '400_cutlery_mat',
                '450_cutlery_mat',
                '500_cutlery_mat',
                '600_cutlery_mat',
                '800_cutlery_mat',
                '900_cutlery_mat',
                '1000_cutlery_mat',
                '900_cutlery_knife_roll_mat',
                '1000_cutlery_knife_spice_mat',
                '1000_cutlery_knife_spice_roll_mat',
                '400_cutlery_spice_mat',
                '600_cutlery_spice_mat',
                '800_cutlery_spice_mat',
                '900_cutlery_spice_mat',
                '800_cutlery_spice_roll_mat',
                '400_knife_mat',
                '450_knife_mat',
                '500_knife_mat',
                '800_knife_mat',
                '900_knife_mat',
                '1000_knife_mat',
                '500_knife_roll_mat',
                '600_knife_roll_mat',
                '1000_knife_roll_mat',
                '500_knife_spice_mat',
                '600_knife_spice_mat',
                '1000_knife_spice_mat',
                '400_spice_mat',
                '450_spice_mat',
                '500_spice_mat', //not handled
                '800_spice_mat',
                '900_spice_mat'
            ],
            choice_order: [
                'none',
                'standard',
                'shelves',
                'split_hanging',
                'fitment',
                'chest',
                'pull_out_150',
                'pull_out_300',
                'pull_out_300_larder',
                'cargo_300',
                'cargo_400',
                'cargo_500',
                'cargo_600',
                'undersink',
                'cutlery_drawer_500',
                'cutlery_drawer_600',
                'cutlery_drawer_800',
                'cutlery_drawer_900',
                'cutlery_drawer_1000',
                'cutlery_mat_400',
                'cutlery_mat_450',
                'cutlery_mat_500',
                'cutlery_mat_600',
                'cutlery_mat_800',
                'cutlery_mat_900',
                'cutlery_mat_1000',
                'cutlery_knife_roll_mat_900',
                'cutlery_knife_spice_roll_mat_1000',
                'cutlery_knife_spice_mat_1000',
                'cutlery_knife_mat_400',
                'cutlery_knife_mat_600',
                'cutlery_knife_mat_800',
                'cutlery_knife_mat_900',
                'cutlery_knife_mat_1000',
                'cutlery_spice_roll_mat_800',
                'cutlery_spice_mat_400',
                'cutlery_spice_mat_600',
                'cutlery_spice_mat_800',
                'cutlery_spice_mat_900',
                'knife_mat_400',
                'knife_mat_450',
                'knife_mat_500',
                'knife_mat_800',
                'knife_mat_900',
                'knife_mat_1000',
                'knife_roll_mat_500',
                'knife_roll_mat_600',
                'knife_roll_mat_1000',
                'knife_spice_mat_500',
                'knife_spice_mat_600',
                'knife_spice_mat_1000',
                'spice_mat_400',
                'spice_mat_450',
                'spice_mat_500',
                'spice_mat_800',
                //'spice_mat_1000'
            ],

            applyInitState: function (product) {
                this.super(product);
                if (product) {
                    initSimpleServerOption(model.option_id, product);
                    if (product.is_single_wardrobe) {
                        for (let choiceID in model.choices) {
                            const choice = model.choices[choiceID];
                            if (choice.single && choice.single.img_src) {
                                choice.img_src = choice.single.img_src;
                            }
                        }
                    }
                }
            },

            applyCurrentState: function (product) {
                let currentID = product.option_term_ids[model.option_id];
                let i, hingeHoleOption;
                if (['pull_out_150', 'pull_out_300', 'cargo_300', 'cargo_400', 'cargo_500', 'cargo_600'].includes(currentID)) {
                    product.hinge_hole_side = "none";
                    if (product.hinge_hole_options) {
                        for (i = 0; i < product.hinge_hole_options.length; i++) {
                            hingeHoleOption = product.hinge_hole_options[i];
                            if (hingeHoleOption.value !== "none") {
                                if (!hingeHoleOption.hidden_by) {
                                    hingeHoleOption.hidden_by = [];
                                }
                                if (hingeHoleOption.hidden_by.indexOf("internal") === -1) {
                                    hingeHoleOption.hidden_by.push("internal");
                                }
                            }

                        }
                    }
                } else {
                    if (product.hinge_hole_options) {
                        for (i = 0; i < product.hinge_hole_options.length; i++) {
                            hingeHoleOption = product.hinge_hole_options[i];
                            if (hingeHoleOption.hidden_by) {
                                while (hingeHoleOption.hidden_by.indexOf("internal") !== -1) {
                                    const index = hingeHoleOption.hidden_by.indexOf("internal");
                                    hingeHoleOption.hidden_by.splice(index, 1);
                                }
                                if (hingeHoleOption.hidden_by.length === 0) {
                                    delete hingeHoleOption.hidden_by;
                                }

                            }

                        }
                    }
                }
                return false;
            }
        };
    }

    function getInternalLeftValues(model, variationIDs) {

        return {
            name: "Left Internals",
            error_message: "You must select your left internal",
            always_visible: true,
            details: {
                messages: [],
            },
            choices: {
                standard: new ModelChoice({
                    name: "Single Hanging",
                    img_src: "/img/browse/option/internal-left/internal-left-single-hanging.png"
                }),
                shelves: new ModelChoice({
                    name: "Shelves",
                    img_src: "/img/browse/option/internal-left/internal-left-shelves.png"
                }),
                split_hanging: new ModelChoice({
                    name: "Split Hanging",
                    img_src: "/img/browse/option/internal-left/internal-left-split-hanging.png"
                }),
                fitment: new ModelChoice({
                    name: "Fitment",
                    img_src: "/img/browse/option/internal-left/internal-left-fitment.png"
                }),
                chest: new ModelChoice({
                    name: "Chest",
                    img_src: "/img/browse/option/internal-left/internal-left-chest.png"
                }),
                none: new ModelChoice({
                    name: "No Internal",
                    img_src: "/img/browse/option/no-image.jpg"
                })
            },
            choice_order: ['standard', 'shelves', 'split_hanging', 'fitment', 'chest', 'none'],
            applyInitState: function (product) {
                this.super(product);
                if (product) {
                    initSimpleServerOption(model.option_id, product);
                }
            }
        };
    }

    function getInternalRightValues(model, variationIDs) {

        return {
            name: "Right Internals",
            error_message: "You must select right internal",
            always_visible: true,
            details: {
                messages: [],
            },
            choices: {
                standard: new ModelChoice({
                    name: "Single Hanging",
                    img_src: "/img/browse/option/internal-right/internal-right-single-hanging.png"
                }),
                shelves: new ModelChoice({
                    name: "Shelves",
                    img_src: "/img/browse/option/internal-right/internal-right-shelves.png"
                }),
                split_hanging: new ModelChoice({
                    name: "Split Hanging",
                    img_src: "/img/browse/option/internal-right/internal-right-split-hanging.png"
                }),
                fitment: new ModelChoice({
                    name: "Fitment",
                    img_src: "/img/browse/option/internal-right/internal-right-fitment.png"
                }),
                chest: new ModelChoice({
                    name: "Chest",
                    img_src: "/img/browse/option/internal-right/internal-right-chest.png"
                }),
                none: new ModelChoice({
                    name: "No Internal",
                    img_src: "/img/browse/option/no-image.jpg"
                })
            },
            choice_order: ['standard', 'shelves', 'split_hanging', 'fitment', 'chest', 'none'],
            applyInitState: function (product) {
                this.super(product);
                if (product) {
                    initSimpleServerOption(model.option_id, product);
                }
            }
        };
    }

    function getWinglineInternalLeftValues(model, variationIDs) {

        return {
            name: "Left Internals",
            error_message: "You must select your left internal",
            always_visible: true,
            details: {
                messages: [],
            },
            choices: {
                standard: new ModelChoice({
                    name: "Single Hanging",
                    img_src: "/img/browse/option/internal/internal-double-single-hanging.png",
                }),
                shelves: new ModelChoice({
                    name: "Shelves",
                    img_src: "/img/browse/option/internal/internal-double-shelves.png",
                }),
                split_hanging: new ModelChoice({
                    name: "Split Hanging",
                    img_src: "/img/browse/option/internal/internal-double-split-hanging.png",
                }),
                fitment: new ModelChoice({
                    name: "Fitment",
                    img_src: "/img/browse/option/internal/internal-double-fitment.png"
                }),
                chest: new ModelChoice({
                    name: "Chest",
                    img_src: "/img/browse/option/internal/internal-double-chest.jpg"
                }),
                none: new ModelChoice({
                    name: "No Internal",
                    img_src: "/img/browse/option/no-image.jpg"
                })
            },
            choice_order: ['standard', 'shelves', 'split_hanging', 'fitment', 'chest', 'none'],
            applyInitState: function (product) {
                this.super(product);
                if (product) {
                    initSimpleServerOption(model.option_id, product);
                }
            }
        };
    }

    function getWinglineInternalRightValues(model, variationIDs) {

        return {
            name: "Right Internals",
            error_message: "You must select right internal",
            always_visible: true,
            details: {
                messages: [],
            },
            choices: {
                standard: new ModelChoice({
                    name: "Single Hanging",
                    img_src: "/img/browse/option/internal/internal-double-single-hanging.png",
                }),
                shelves: new ModelChoice({
                    name: "Shelves",
                    img_src: "/img/browse/option/internal/internal-double-shelves.png",
                }),
                split_hanging: new ModelChoice({
                    name: "Split Hanging",
                    img_src: "/img/browse/option/internal/internal-double-split-hanging.png",
                }),
                fitment: new ModelChoice({
                    name: "Fitment",
                    img_src: "/img/browse/option/internal/internal-double-fitment.png"
                }),
                chest: new ModelChoice({
                    name: "Chest",
                    img_src: "/img/browse/option/internal/internal-double-chest.jpg"
                }),
                none: new ModelChoice({
                    name: "No Internal",
                    img_src: "/img/browse/option/no-image.jpg"
                })
            },
            choice_order: ['standard', 'shelves', 'split_hanging', 'fitment', 'chest', 'none'],
            applyInitState: function (product) {
                this.super(product);
                if (product) {
                    initSimpleServerOption(model.option_id, product);
                }
            }
        };
    }

    function getDripTrayValues(model, variationIDs) {

        return {
            name: "Sink Unit Protector Required?",
            always_visible: true,
            layout: "simple_radio",
            details: {
                messages: [],
            },
            choices: {
                none: new ModelChoice({
                    name: "No"
                }),
                drip_tray: new ModelChoice({
                    name: "Yes"
                })
            },
            choice_order: [
                'none',
                'drip_tray'
            ],
            applyInitState: function (product) {
                this.super(product);
                if (product) {
                    initSimpleServerOption(model.option_id, product);
                }
            }
        };
    }

    function getDoorSizeValues(model, variationIDs) {

        return {
            name: "Door Size",
            error_message: "You must select your door size",
            always_visible: true,
            layout: "dropdown",
            choices: {
                d715x446: new ModelChoice({
                    name: "715x446"
                }),
                d715x496: new ModelChoice({
                    name: "715x496"
                }),
                d715x596: new ModelChoice({
                    name: "715x596"
                }),
                d895x446: new ModelChoice({
                    name: "895x446"
                }),
                d895x496: new ModelChoice({
                    name: "895x496"
                }),
                d895x596: new ModelChoice({
                    name: "895x596"
                }),
            },
            choice_order: [
                'd715x446',
                'd715x496',
                'd715x596',
                'd895x446',
                'd895x496',
                'd895x596'
            ],
        };
    }

    function getDoorSlopingAngleValues(model, variationIDs) {

        return {
            name: "Left & Right Angles",
            input_section_list: [
                {
                    required: true,
                    error_message: "At least one valid angle must be specified (Angle Height & Width)",
                    input_list: [
                        {
                            type: 'number',
                            id: 'left_angle_height',
                            name: 'Left Angle Height (LAH)',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'left_angle_width',
                            name: 'Left Angle Width (LAW)',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'right_angle_height',
                            name: 'Right Angle Height (RAH)',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'right_angle_width',
                            name: 'Right Angle Width (RAW)',
                            explanation: 'mm'
                        }
                    ]
                }
            ]
        };
    }

    function getDoorSlopingSpacingValues(model, variationIDs) {

        return {
            name: "Spacing between doors",
            input_section_list: [
                {
                    input_list: [
                        {
                            type: 'number',
                            id: 'left_spacing',
                            name: 'Left side spacing',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'right_spacing',
                            name: 'Right side spacing',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'top_spacing',
                            name: 'Top spacing',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'bottom_spacing',
                            name: 'Bottom spacing',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'left_angle_spacing',
                            name: 'Left angle spacing',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'right_angle_spacing',
                            name: 'Right angle spacing',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'door_spacing',
                            name: 'Spacing between doors',
                            explanation: 'mm'
                        }
                    ]
                }
            ]
        };
    }

    function getPanelProfiledEdgeValues(model, variationIDs) {

        return {
            name: "Profiled Edge",
            input_section_list: [
                {
                    required: true,
                    message: "Profiled edges are highlighted in red on the diagram.",
                    error_message: "At least one Profiled Edge must be specified",
                    input_list: [
                        {
                            type: 'checkbox',
                            id: 'front_profiled',
                            name: 'Front'
                        },
                        {
                            type: 'checkbox',
                            id: 'back_profiled',
                            name: 'Back'
                        },
                        {
                            type: 'checkbox',
                            id: 'left_profiled',
                            name: 'Left'
                        },
                        {
                            type: 'checkbox',
                            id: 'right_profiled',
                            name: 'Right'
                        }
                    ]
                }
            ],

            applyInitState: function (product) {
                this.super(product);
                if (product) {
                    if (product.type === "angled_top" || product.type === "radius_top") {
                        model.input_section_list[0].required = false;
                    }
                }
            }
        };
    }

    function getPanelAngleValues(model, variationIDs) {

        return {
            name: "Angles",
            input_section_list: [
                {
                    id: "angle_size_section",
                    message: "Note: Angled corners will be automatically profiled.",
                    input_list: [
                        {
                            type: 'number',
                            id: 'angle_length',
                            name: 'Angle Length (AL)',
                            required: true,
                            min: 1,
                            required_error: "This product requires an angle length (AL).",
                            max_error: "The angle length (AL) is greater than the panel length (L)."
                        },
                        {
                            type: 'number',
                            id: 'angle_depth',
                            name: 'Angle Depth (AD)',
                            required: true,
                            min: 1,
                            required_error: "This product requires an angle depth (AD).",
                            max_error: "The angle depth (AD) is greater than the panel depth (D)."
                        },
                    ]
                },
                {
                    id: "angles_required_section",
                    name: 'Angles Required',
                    required: true,
                    error_message: "At least one angle position must be specified.",
                    input_list: [
                        {
                            type: 'checkbox',
                            id: 'front_left_angle',
                            name: 'Front Left'
                        },
                        {
                            type: 'checkbox',
                            id: 'front_right_angle',
                            name: 'Front Right'
                        },
                        {
                            type: 'checkbox',
                            id: 'back_left_angle',
                            name: 'Back Left'
                        },
                        {
                            type: 'checkbox',
                            id: 'back_right_angle',
                            name: 'Back Right'
                        }
                    ]
                }

            ],
            applyCurrentState: function (product) {
                if (!product) {
                    return false;
                }
                for (let i = 0; i < model.input_section_list.length; i++) {
                    const inputSection = model.input_section_list[i];
                    if (inputSection.id === "angle_size_section") {
                        for (let j = 0; j < inputSection.input_list.length; j++) {
                            const input = inputSection.input_list[j];
                            if (input.id === "angle_length") {
                                input.max = product.length ? product.length : 1;
                                input.explanation = "1mm - " + (product.length ? product.length : 1) + "mm"
                            } else if (input.id === "angle_depth") {
                                input.max = product.depth ? product.depth : 1;
                                input.explanation = "1mm - " + (product.depth ? product.depth : 1) + "mm"
                            }
                        }
                        break;
                    }
                }
                return false;
            },
        };
    }

    function getPanelRadiusValues(model, variationIDs) {

        return {
            name: "Radius",
            input_section_list: [
                {
                    required: true,

                    error_message: "At least one Radius must be specified",

                    input_list: [
                        {
                            type: 'number',
                            id: 'front_left_radius',
                            name: 'Front Left Radius (FLR)',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'front_right_radius',
                            name: 'Front Right Radius (FRR)',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'back_left_radius',
                            name: 'Back Left Radius (BLR)',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'back_right_radius',
                            name: 'Back Right Radius (BRR)',
                            explanation: 'mm'
                        }
                    ]
                }
            ]
        };
    }

    function getPanelCornerPositionValues(model, variationIDs) {

        return {
            name: "Corner Position",
            input_section_list: [
                {

                    input_list: [
                        {
                            type: 'radio',
                            id: 'corner_position',
                            required: true,
                            required_error: "Please select a corner position.",
                            choices: [
                                {
                                    value: "left",
                                    name: "Left Corner"
                                },
                                {
                                    value: "right",
                                    name: "Right Corner"
                                }
                            ]
                        }
                    ]
                }
            ]
        };
    }

    function getPanelSideAngleValues(model, variationIDs) {

        return {
            name: "Side & Angle",
            input_section_list: [
                {
                    id: "angle_size_section",
                    input_list: [
                        {
                            type: 'number',
                            id: 'side_length',
                            name: 'Side Length (SL)',
                            explanation: 'mm',
                            required: true,
                            min: 1,
                            required_error: "This product requires an side length (SL).",
                            max_error: "The side length (AL) is greater than the panel length (L)."
                        },
                        {
                            type: 'number',
                            id: 'side_depth',
                            name: 'Side Depth (SD)',
                            explanation: 'mm',
                            required: true,
                            min: 1,
                            required_error: "This product requires an side depth (SL).",
                            max_error: "The side depth (SD) is greater than the panel depth (D)."
                        },
                        {
                            type: 'number',
                            id: 'angle_length',
                            name: 'Angle Length (AL)',
                            explanation: 'mm',
                            required: true,
                            min: 1,
                            required_error: "This product requires an angle length (AL).",
                            max_error: "The angle length (AL) is greater than the panel length (L)."
                        },
                        {
                            type: 'number',
                            id: 'angle_depth',
                            name: 'Angle Depth (AD)',
                            explanation: 'mm',
                            required: true,
                            min: 1,
                            required_error: "This product requires an angle depth (AD)",
                            max_error: "The angle depth (AD) is greater than the panel depth (D)."
                        }
                    ]
                }
            ],
            applyCurrentState: function (product) {
                if (!product) {
                    return false;
                }
                for (let i = 0; i < model.input_section_list.length; i++) {
                    const inputSection = model.input_section_list[i];
                    if (inputSection.id === "angle_size_section") {
                        for (let j = 0; j < inputSection.input_list.length; j++) {
                            const input = inputSection.input_list[j];
                            if (input.id === "side_length" || input.id === "angle_length") {
                                input.max = product.length ? product.length : 1;
                                input.explanation = "1mm - " + (product.length ? product.length : 1) + "mm"
                            } else if (input.id === "side_depth" || input.id === "angle_depth") {
                                input.max = product.depth ? product.depth : 1;
                                input.explanation = "1mm - " + (product.depth ? product.depth : 1) + "mm"
                            }
                        }
                        break;
                    }
                }
                return false;
            },
        };
    }

    function getPanelCornerRadiusValues(model, variationIDs) {

        return {
            name: "Radius",
            input_section_list: [
                {
                    input_list: [
                        {
                            type: 'number',
                            id: 'corner_radius',
                            name: 'Corner Radius (CR)',
                            explanation: 'mm'
                        },
                        {
                            type: 'number',
                            id: 'middle_radius',
                            name: 'Middle Radius (LR)',
                            explanation: 'mm'
                        }
                    ]
                }
            ]
        };
    }

    function getPanelCornerProfileValues(model, variationIDs) {

        return {
            name: "Profile",
            input_section_list: [
                {

                    message: "Profiled edges are highlighted in red on the diagram.",
                    input_list: [
                        {
                            type: 'checkbox',
                            id: 'side_length_profiled',
                            name: 'SL',
                            explanation: 'mm'
                        },
                        {
                            type: 'checkbox',
                            id: 'side_depth_profiled',
                            name: 'SD',
                            explanation: 'mm'
                        }
                    ]
                }
            ]
        };
    }
}])